/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Template_Color_NavyInputs */



/**
* | output |
* | --- |
* | "Navy" |
*
* @param {Settings_Template_Color_NavyInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const settings_template_color_navy = /** @type {((inputs?: Settings_Template_Color_NavyInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Template_Color_NavyInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Marineblauw")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Bleu marine")
	return /** @type {LocalizedString} */ ("Navy")
});